import { useEffect, useState } from "react";
import { getLastUpdated } from "../api/old-vine-registry-api";

export function useLastUpdated(): string {
  const [lastUpdated, setLastUpdated] = useState("");
  useEffect(() => {
    getLastUpdated().then((date) => setLastUpdated(date));
  }, []);
  return lastUpdated;
}
